import odata from '@/core/api/mixin/odata'
import rest from '@/core/api/mixin/rest'

export default {
  ...odata('insight-models'),
  ...rest('insight-models'),
}
